module.exports = __webpack_public_path__ + "static/img/v4_3.df56fd12.png";